export default __webpack_public_path__ + "static/octosign-example3-fbdac28e264fb001d114604c60009244.png";